import React from 'react';
import { View, type StyleProp, type ViewStyle } from 'react-native';
import { useTheme } from '../theme';

/** RN port of theme.css's .t-divider / .t-divider--v. */
export default function Divider({ vertical, style }: { vertical?: boolean; style?: StyleProp<ViewStyle> }) {
  const t = useTheme();
  return (
    <View
      style={[
        vertical
          ? { width: 1, alignSelf: 'stretch', backgroundColor: t.colors.line, marginHorizontal: 8 }
          : { height: 1, backgroundColor: t.colors.line, marginVertical: 12 },
        style,
      ]}
    />
  );
}
